import { ReactNode, useEffect, useRef } from 'react';

import { InteractiveResponseAnswerIcons } from '../../shared/interactive-response-shared';
import {
  InteractiveDropItem,
  InteractiveDropItemTarget,
} from './interactive-response-categorise-drop.style';

export const InteractiveDropDisplay = ({
  children,
  isCorrect,
  hasDropped,
  isContinuousMarking,
  isVisible = true,
  onIncorrectAnswer,
}: {
  children: ReactNode;
  isCorrect?: boolean;
  hasDropped?: boolean;
  isContinuousMarking: boolean;
  isVisible?: boolean;
  onIncorrectAnswer?: (el: HTMLDivElement) => void;
}) => {
  const droppedDragItemRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (isCorrect !== undefined && isContinuousMarking) {
      setTimeout(() => {
        if (!isCorrect && droppedDragItemRef.current) {
          onIncorrectAnswer?.(droppedDragItemRef.current);
        }
      }, 1000);
    }
    //eslint-disable-next-line
  }, [isCorrect]);

  return (
    <InteractiveDropItem>
      <InteractiveDropItemTarget
        $isOver={false}
        $canDrop={false}
        $hasDropped={hasDropped}
        $isCorrect={isCorrect}
        $isResponsive={false}
        $isVisible={isVisible}
      >
        <InteractiveResponseAnswerIcons isCorrect={isCorrect} />
        <div ref={droppedDragItemRef}>{children}</div>
      </InteractiveDropItemTarget>
    </InteractiveDropItem>
  );
};
